/** @file NODE_KEYS_CHECK: the field check of a key's node map (format `NodeKey` per node name). */
import { checkBoolean } from '@zilo/pose3d-format/validate/fields/checkBoolean';
import { checkEnum } from '@zilo/pose3d-format/validate/fields/checkEnum';
import { checkNumber } from '@zilo/pose3d-format/validate/fields/checkNumber';
import { checkRecord } from '@zilo/pose3d-format/validate/fields/checkRecord';
import { checkShape } from '@zilo/pose3d-format/validate/fields/checkShape';
import { checkString } from '@zilo/pose3d-format/validate/fields/checkString';
import { checkTuple } from '@zilo/pose3d-format/validate/fields/checkTuple';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { NAME_PATTERN } from '@zilo/pose3d-format/validate/fields/namePattern';

const flexParent: FieldCheck = (v, p) => { if (v !== null) checkString(NAME_PATTERN)(v, p); };

/** Node name → `{ rot?, pos?, scale?, parent?, rotToggle?, hidden?, ease?, hold? }` (the clip document's rules). */
export const NODE_KEYS_CHECK: FieldCheck = checkRecord(checkShape({
  required: {},
  optional: {
    rot: checkTuple(3), pos: checkTuple(3), scale: checkNumber({ above: 0 }), parent: flexParent, rotToggle: checkBoolean, hidden: checkBoolean,
    ease: checkEnum(['linear', 'easeIn', 'easeOut', 'easeInOut', 'step']), hold: checkNumber({ int: true, min: 1 }),
  },
}));
